import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrl: './empty-state.component.scss'
})
export class EmptyStateComponent {
  @Input() icon: string = 'inbox';
  @Input() title: string = 'No data available';
  @Input() description: string = 'No items found to display at this time.';
  @Input() showIcon: boolean = true;
  @Input() iconSize: 'sm' | 'md' | 'lg' = 'md';
  @Input() variant: 'default' | 'minimal' = 'default';
}
